import { type FC, type PropsWithChildren } from 'react';
import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Modal, ModalContent } from '@/components/ui/modal';
import { ModalId } from '@/hooks/data/modal/useModalStore';

export const CreateNoteDialog: FC<PropsWithChildren & { title: string }> = ({ title, children }) => {
  return (
    <Modal id={ModalId.CreateAssetNotes}>
      <ModalContent autoFocus onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only" />
        </DialogHeader>
        {children}
      </ModalContent>
    </Modal>
  );
};
